import React, { FC, useState } from 'react'

interface IProps {
  content: React.ReactNode
}

export const InfoTooltip: FC<IProps> = ({ content }) => {
  const [visible, setVisible] = useState(false)

  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <i
        className='bi bi-info-circle'
        style={{ fontSize: '1rem', color: 'var(--color-primary-blue)', cursor: 'pointer' }}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      />
      {visible && (
        <div
          style={{
            position: 'absolute',
            left: 'calc(100% + 10px)',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1000,
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            padding: '12px 16px',
            minWidth: 210,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
          }}
        >
          {content}
        </div>
      )}
    </span>
  )
}
